import { Route } from '@angular/router';
import { RoleGuard } from './core/guard/role.guard';
import { b2bContextGuard } from './core/guard/b2b-context.guard';
import { homeRedirectGuard } from './core/guard/home-redirect.guard';
import { ADMIN_ALLOWED_ROLES } from './core/services/http/auth/auth.service';
import { agentRoutes } from './features/app/admin/pages/agent/agent.routes';
import { managementRoutes } from './features/app/admin/pages/management/management.routes';
import { partnerRoutes } from './features/app/admin/pages/partner/partner.routes';
import { productParametersRoutes } from './features/app/admin/pages/product-parameters/product-parameters.routes';
import { userParametersRoutes } from './features/app/admin/pages/user-parameters/user-parameters.routes';

export const appRoutes: Route[] = [
  {
    path: '',
    redirectTo: 'admin',
    pathMatch: 'full',
  },
  {
    path: 'login',
    loadComponent: () =>
      import('./features/auth/login/login.component').then(module => module.LoginComponent),
  },
  {
    path: 'admin',
    loadComponent: () =>
      import('./features/app/admin/admin.component').then(module => module.AdminComponent),
    canActivate: [RoleGuard, b2bContextGuard],
    canActivateChild: [RoleGuard],
    data: { roles: [...ADMIN_ALLOWED_ROLES] },
    children: [
      managementRoutes,
      partnerRoutes,
      productParametersRoutes,
      userParametersRoutes,
      agentRoutes,
      {
        path: '',
        pathMatch: 'full',
        // агент — в кабинет или на продажи (по режиму сотрудничества из /b2b/me/context), остальные — на обмены
        canActivate: [homeRedirectGuard],
        children: [],
      },
    ],
  },
];
